(() => {
  'use strict';
  if (window.fortunatoPrivacyControlsReady) return;
  window.fortunatoPrivacyControlsReady = true;

  const revealControls = () => {
    document.querySelectorAll('[data-sl-cookie-preferences]').forEach((button) => {
      button.hidden = false;
    });
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-sl-cookie-preferences]');
    if (!button || button.disabled) return;
    const status = document.getElementById(button.getAttribute('aria-describedby'));
    if (status) status.hidden = true;
    button.disabled = true;
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') {
        throw new Error('Preferences unavailable');
      }
      await window.privacyBanner.showPreferences();
    } catch {
      if (status) status.hidden = false;
    } finally {
      button.disabled = false;
    }
  });

  revealControls();
  document.addEventListener('shopify:section:load', revealControls);
})();
